import React, { useEffect, useState } from "react";
import { FormProvider } from "../../../../common/provider/form/Form.provider";
import { Form, Input } from "antd";
import { SimpleInput } from "../../../../common/components/simpleInput";

import style from "../../../../common/styles/styleForm.module.scss";
import { CustomButton } from "../../../../common/components/CustomButton/CustomButton";
import { useSearchParams } from "react-router";
import { InputSelect } from "../../../../common/components/InputSelect/InputSelect";
import { API_URLs } from "../../../../utilities/API_URLs";
import { DamagedConstant } from "../core/_constant";
import { DamagedService } from "../core/_request";
import { HttpStatusCode } from "axios";

type DamagedFormType = {
  onFinish: () => void;
  initialValue?: any;
};
export const DamagedForm = ({ onFinish, initialValue }: DamagedFormType) => {
  const [form] = Form.useForm();

  const [searchParams] = useSearchParams();
  const loadType = searchParams.get("type");

  const [initialState] = useState<any>({
    loadType: `/api/load_types/${loadType?.toUpperCase()}`,
  });
  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);

  useEffect(() => {
    form.setFieldsValue(initialState);
  }, []);

  useEffect(() => {
    // form.setFieldsValue(initialState);
    const formatInitialValue = {
      loadSubType: {
        value: initialValue?.loadSubType,
      },
      name: initialValue?.name,
      ...(initialValue?.id ? { id: initialValue?.id } : {}),
    };

    form?.setFieldsValue(formatInitialValue);
  }, [initialValue]);

  const onSubmitHandler = async (values: any) => {
    try {
      setIsLoadingSubmit(true);
      const formatedData = {
        ...(values?.id ? { id: values?.id } : {}),
        ...(values?.loadSubType
          ? { loadSubType: values?.loadSubType?.value }
          : {}),
        name: values?.name,
        loadType: values?.loadType,
      };

      if (!values?.id) {
        // Create
        const res = await DamagedService.createDamaged(formatedData);
        if (res?.status === HttpStatusCode.Created) {
          onFinish();
          form?.resetFields();
        }
      } else {
        // Edit

        const res = await DamagedService.updateDamaged(formatedData);
        if (res?.status === HttpStatusCode.Ok) {
          onFinish();
          form?.resetFields();
        }
      }
    } catch (error) {
    } finally {
      setIsLoadingSubmit(false);
    }
  };

  return (
    <div>
      <FormProvider
        Form={Form}
        form={form}
        debug={true}
        onFinish={(values: any) => {
          onSubmitHandler(values);
        }}
        onFinishFailed={(err) => {
          console.log("err", err);
        }}
      >
        <div className="d-none">
          <SimpleInput
            Form={Form}
            label="ID"
            name={"id"}
            customInput={<Input />}
          />
          <SimpleInput
            Form={Form}
            label="loadType"
            name={"loadType"}
            customInput={<Input value={initialState?.loadType} />}
          />
        </div>

        <div className={style.form}>
          <div className={style.form__item_wrapper}>
            <div className={style.form__item}>
              <SimpleInput
                Form={Form}
                label="Nom"
                name={"name"}
                rules={[
                  {
                    required: true,
                    message: `Ce champ est requis`,
                  },
                ]}
                customInput={<Input />}
              />
            </div>
          </div>
          {loadType?.toUpperCase() === DamagedConstant.AVARIE_TYPE.container ? (
            <div className={style.form__item_wrapper}>
              <div className={style.form__item}>
                <SimpleInput
                  Form={Form}
                  label="Type de conteneur"
                  name={"loadSubType"}
                  rules={[
                    {
                      required: true,
                      message: `Ce champ est requis`,
                    },
                  ]}
                  customInput={
                    <InputSelect
                      valueOption={{
                        labelKey: "name",
                        valueKey: "id",
                      }}
                      uri={`${API_URLs.settings.containerType.getContainerCategoryForSelect}`}
                      onChange={(e) => {
                        console.log(e);
                      }}
                    />
                  }
                />
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className={style.form__action_wrapper}>
          <CustomButton
            type="submit"
            className={style.form__action_button}
            isLoading={isLoadingSubmit}
          >
            Enregistrer
          </CustomButton>
        </div>
      </FormProvider>
    </div>
  );
};
